import React, { useState, useMemo, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Navbar from "../../../Shared/Navbar/Navbar";
import "bootstrap/dist/css/bootstrap.min.css";
import { useQuery, useQueryClient } from '@tanstack/react-query';
import {
  FaEdit,
  FaEye,
  FaComment,
  FaTrash, 
  FaCalendarAlt,
  FaTimes,
  FaCopy,
  FaDownload, FaSave, FaSpinner, FaDollarSign, FaRupeeSign,
} from "react-icons/fa";
import { Row, Col ,Form} from "react-bootstrap";
import DataTable from "../../../Layout/Table/TableLayoutOpp";
import { adminMail, baseURL } from "../../../Apiservices/Api";
import "./PotentialLeads.css";
import axios from "axios";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { HiOutlinePaperClip, HiUserGroup } from "react-icons/hi";
import { FontSizeContext } from "../../../Shared/Font/FontContext";
import Loader from "../../../Loader/Loader";
import { Modal, Button } from "react-bootstrap";
import CommentsModalpop from '../../Admin/Leads/ViewLeads/CommentsModalPop/CommentsModalpop'; 
import EmailCommentModalPop from "../Leads/ViewLeads/Comment/EmailCommentModalPop/EmailCommentModalPop";
import My_EmailHistory from "../Leads/ViewLeads/Comment/EmailCommentModalPop/EmailCommentModalPopadmin";

const Potentialleads = () => {
    const queryClient = useQueryClient();
  const { authToken, userId } = useContext(AuthContext);
  const { fontSize } = useContext(FontSizeContext);
  const [message, setMessage] = useState("");
  const [collapsed, setCollapsed] = useState(false);
  const [associatesByManager, setAssociatesByManager] = useState({});
  const navigate = useNavigate();
  const location = useLocation();
const [showCommentModal, setShowCommentModal] = useState(false);
const [selectedLeadForComment, setSelectedLeadForComment] = useState(null);
  const [pageIndex, setPageIndex] = useState(0);

  const [searchTerm, setSearchTerm] = useState(
    localStorage.getItem("searchTerm") || ""
  );
  const [filterStatus, setFilterStatus] = useState(
    localStorage.getItem("filterStatus") || ""
  );
  const [filterDestination, setFilterDestination] = useState(
    localStorage.getItem("filterDestination") || ""
  );
  const [filterOppStatus1, setFilterOppStatus1] = useState(
    localStorage.getItem("filterOppStatus1") || "In Progress"
  );
  const [filterOppStatus2, setFilterOppStatus2] = useState(
    localStorage.getItem("filterOppStatus2") || ""
  );
   const [filterPrimarySource, setFilterPrimarySource] = useState(
      localStorage.getItem("filterPrimarySource") || ""
    );
    
    const [filterSecondarySource, setFilterSecondarySource] = useState(
      localStorage.getItem("filterSecondarySource") || ""
    );
  const [filterManager, setFilterManager] = useState(
    localStorage.getItem("filterManager") || ""
  );
  const [filterAssignee, setFilterAssignee] = useState(
    localStorage.getItem("filterAssignee") || ""
  );
  const [filterStartDate, setFilterStartDate] = useState(
    localStorage.getItem("filterStartDate") || ""
  );
  const [filterEndDate, setFilterEndDate] = useState(
    localStorage.getItem("filterEndDate") || ""
  );
  const [appliedFilterStartDate, setAppliedFilterStartDate] = useState(
    localStorage.getItem("appliedFilterStartDate") || ""
  );
  const [appliedFilterEndDate, setAppliedFilterEndDate] = useState(
    localStorage.getItem("appliedFilterEndDate") || ""
  );
  // const [showDateRange, setShowDateRange] = useState(false);
  // const [data, setData] = useState([]);
  const [managers, setManagers] = useState([]);
  const [showDateRange, setShowDateRange] = useState(
    localStorage.getItem("showDateRange") === "true"
  );

  const primarySourceOptions = [
  "Referral",
  "Corporate",
  "Partner Promotion",
  "Media Coverage",
  "Blog",
  "Community",
  "Purchased Leads",
  "Social Media",
  "Google",
  "Meta",
  "Other",
];

  const sourceDropdownOptions = {
  Referral: ["Grade 3", "Grade 2", "Grade 1"],
  Corporate: ["BIW", "Others"],
  Community: ["BNI", "Rotary", "Lions", "Association", "Others"],
  "Purchased Leads": ["Tripcrafter", "Others"],
  "Social Media": ["Linkedin", "Others"],
  Google: [
    "Google Organic",
    "Google Ad",
    "Youtube Organic",
    "Youtube Paid",
  ],
  Meta: [ 
    "Facebook Organic",
    "Instagram Organic",
    "Facebook (Paid)",
    "Instagram (Paid)",
    "Others",
  ],
};

  // Add this state with your other state declarations
  const [loading, setLoading] = useState(false);

  // Save state to localStorage when values change
  useEffect(() => {
    localStorage.setItem("showDateRange", showDateRange);
  }, [showDateRange]);



  const copyToClipboard = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setMessage("Copied to clipboard!");
        setTimeout(() => setMessage(""), 1000); // Optional: Show a message
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  // const fetchLeads = async () => {
  //   setLoading(true); // Start loading
  //   try {
  //     const response = await axios.get(`${baseURL}/api/fetch-data-notadmin`);
  //     if (response.status === 200) {
  //       setData(response.data);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching leads:", error);
  //   } finally {
  //     setLoading(false); // Stop loading
  //   }
  // };


const {
  data = [],
  isLoading,
  isError,
  error,
} = useQuery({
  queryKey: ['not-admin-leads'],
  refetchInterval: 3000, // Refetch every 3 seconds to keep data updated
  queryFn: async () => {
    const response = await axios.get(
      `${baseURL}/api/fetch-data-notadmin`
    );

    return response.data;
  },
  keepPreviousData: true,
});


  const fetchManagers = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${baseURL}/employees/managers`);
      setManagers(response.data.data);
    } catch (error) {
      console.error("Error fetching managers:", error);
    }
  };

  useEffect(() => {
    // fetchLeads();
    fetchManagers();
  }, [userId]);

  const handleAssignToChange = async (assignee, leadid, managerid, status) => {
  // ✅ Optimistic — instant UI update
  queryClient.setQueryData(['not-admin-leads'], (old = []) =>
    old.map((lead) =>
      lead.leadid == leadid
        ? { ...lead, assign_to_manager: assignee, managerid }
        : lead
    )
  );
 
  try {
    const response = await fetch(`${baseURL}/update-assignee`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ leadid, assignee, managerid, status }),
    });
    const resData = await response.json();
    setMessage(resData.message);
    setTimeout(() => setMessage(''), 1000);
  } catch {
    queryClient.invalidateQueries(['not-admin-leads']); // ✅ rollback
    setMessage('Assign failed, reverting...');
    setTimeout(() => setMessage(''), 1000);
  }
};

  useEffect(() => {
    const fetchAssociatesForManagers = async () => {
      const associatesData = {};
      for (const manager of managers) {
        try {
          const response = await fetch(`${baseURL}/associates/${manager.id}`);
          const data = await response.json();
          associatesData[manager.id] = data;
        } catch (error) {
          console.error("Error fetching associates: ", error);
        }
      }
      setAssociatesByManager(associatesData);
    };

    if (managers.length > 0) {
      fetchAssociatesForManagers();
    }
  }, [managers]);

const handleSelfAssign = async (leadid) => {
  // ✅ Optimistic — remove from list instantly
  queryClient.setQueryData(['not-admin-leads'], (old = []) =>
    old.filter((lead) => lead.leadid != leadid)
  );
 
  try {
    const response = await axios.post(`${baseURL}/api/assign-admin`, { leadid });
    setMessage(response.data.message);
    setTimeout(() => setMessage(''), 1000);
  } catch {
    queryClient.invalidateQueries(['not-admin-leads']); // ✅ rollback
    setMessage('Self assign failed, reverting...');
    setTimeout(() => setMessage(''), 1000);
  }
};

   const [dropdownOptions, setDropdownOptions] = useState({
    primary: [],
    secondary: {}
  });
  
  useEffect(() => {
    fetchLeadStatus();
  }, []);
  
  const fetchLeadStatus = async () => {
    try {
      const res = await axios.get(`${baseURL}/api/opp-status`);
      
      setDropdownOptions({
        primary: res.data.primary || [],
        secondary: res.data.secondary || {}
      });
  
    } catch (error) {
      console.error("Error fetching lead status:", error);
    }
  };
  

  // const dropdownOptions = {
  //   primary: ["In Progress", "Confirmed", "Lost", "Duplicate"],
  //   secondary: {
  //     "In Progress": [
  //       "Understood Requirement",
  //       "Sent first quote",
  //       "Amendment Requested",
  //       "Sent amended quote",
  //       "Negotiation Process",
  //       "Verbally Confirmed-Awaiting token amount",
  //     ],
  //     Confirmed: ["Upcoming Trip", "Ongoing Trip", "Trip Completed"],
  //     Lost: [
  //       "Plan Cancelled",
  //       "Plan Postponed",
  //       "High Quote",
  //       "Low Budget",
  //       "No response",
  //       "Options not available",
  //       "just checking price",
  //       "Self Booked",
  //       "Booked from other source",
  //       "Delay in quote",
  //       "Concern about reliability/trust",
  //       "Did not like payment terms",
  //       "Did not like cancellation policy",
  //       "Booked different option from us",
  //     ],
  //     Duplicate: ["Duplicate"],
  //   },
  // };




const updateOpportunityStatus = async (leadId, primaryStatus, secondaryStatus) => {
  // ✅ Optimistic — instant UI update
  queryClient.setQueryData(['not-admin-leads'], (old = []) =>
    old.map((r) =>
      r.leadid === leadId
        ? {
            ...r,
            opportunity_status1: primaryStatus,
            opportunity_status2: secondaryStatus || '',
          }
        : r
    )
  );
 
  try {
    const response = await axios.put(`${baseURL}/api/update-status/${leadId}`, {
      opportunity_status1: primaryStatus,
      opportunity_status2: secondaryStatus || '',
    });
    if (response.status === 200) {
      setMessage('Status updated successfully.');
      setTimeout(() => setMessage(''), 3000);
      return true;
    }
  } catch {
    queryClient.invalidateQueries(['not-admin-leads']); // ✅ rollback
    setMessage('Update failed, reverting...');
    setTimeout(() => setMessage(''), 3000);
  }
  return false;
};



    useEffect(() => {
      const params = new URLSearchParams(location.search);
      const pageFromUrl = parseInt(params.get("page"));
      const pageSizeFromUrl = parseInt(params.get("pageSize"));
      
      if (!isNaN(pageFromUrl)) {
        setPageIndex(pageFromUrl - 1);
      }
      
    }, [location.search]);


  const handleEdit = (rowId, currentPage) => {
             const params = new URLSearchParams(location.search);
  const pageSize = params.get('pageSize') || '20';

    console.log("Navigating with lead ID:", rowId); 
    if (!rowId) {
      console.error("Invalid rowId:", rowId);
      return;
    }
    navigate(`/a-edit-opportunity/${rowId}?page=${currentPage + 1}&pageSize=${pageSize}`, { state: { leadid: rowId } });
  };

const handleCommentClick = (lead) => {
  setSelectedLeadForComment(lead);
  setShowCommentModal(true);
};


 const handleArchive = async (leadid) => {
  if (!window.confirm('Are you sure you want to archive this Opportunity?')) return;
 
  // ✅ Optimistic — remove instantly
  queryClient.setQueryData(['not-admin-leads'], (old = []) =>
    old.filter((item) => item.leadid !== leadid)
  );
 
  try {
    await fetch(`${baseURL}/api/archiveByLeadId/${leadid}`, { method: 'PUT' });
    setMessage('Opportunity archived successfully.');
    setTimeout(() => setMessage(''), 1000);
  } catch {
    queryClient.invalidateQueries(['not-admin-leads']); // ✅ rollback
    setMessage('Archive failed, reverting...');
    setTimeout(() => setMessage(''), 1000);
  }
};


  useEffect(() => {
    localStorage.setItem("searchTerm", searchTerm);
    localStorage.setItem("filterStatus", filterStatus);
    localStorage.setItem("filterDestination", filterDestination);
    localStorage.setItem("filterOppStatus1", filterOppStatus1);
    localStorage.setItem("filterOppStatus2", filterOppStatus2);
    localStorage.setItem("filterManager", filterManager);
    localStorage.setItem("filterAssignee", filterAssignee);
      localStorage.setItem("filterPrimarySource", filterPrimarySource);
    localStorage.setItem("filterSecondarySource", filterSecondarySource);
    localStorage.setItem("filterStartDate", filterStartDate);
    localStorage.setItem("filterEndDate", filterEndDate);
    localStorage.setItem("appliedFilterStartDate", appliedFilterStartDate);
    localStorage.setItem("appliedFilterEndDate", appliedFilterEndDate);
  }, [
    searchTerm,
    filterStatus,
    filterDestination,
    filterOppStatus1,
    filterOppStatus2,
    filterManager,
    filterAssignee,
    filterStartDate,
    filterPrimarySource,
    filterSecondarySource,
    filterEndDate,
    appliedFilterStartDate,
    appliedFilterEndDate,
  ]);

  const clearFilters = () => {
    setSearchTerm("");
    setFilterStatus("");
    setFilterDestination("");
    setFilterOppStatus1("In Progress");
    setFilterOppStatus2("");
    setFilterPrimarySource(""); 
    setFilterSecondarySource("");
    setFilterManager("");
    setFilterAssignee("");
    setFilterStartDate("");
    setFilterEndDate("");
    setAppliedFilterStartDate("");
    setAppliedFilterEndDate("");
        setPageIndex(0);
  const url = new URL(window.location);
  url.searchParams.delete('page');
        url.searchParams.set('pageSize', '20'); 
      url.searchParams.delete('pageSize');
  window.history.pushState({}, '', url);

    localStorage.removeItem("potentialLeadsFilters");
  };

  const filteredData = useMemo(() => {
    return data.filter((item) => {
      const matchesFreeText =
        !searchTerm ||
        Object.values(item).some(
          (val) =>
            val &&
            val.toString().toLowerCase().includes(searchTerm.toLowerCase())
        );
      const matchesStatus =
        !filterStatus ||
        (item.status &&
          item.status.toLowerCase() == filterStatus.toLowerCase());
      const matchesDestination =
        !filterDestination ||
        (item.travel_destination &&
          item.travel_destination.toLowerCase() ==
          filterDestination.toLowerCase());
      const actualPrimaryStatus = item.opportunity_status1
        ? item.opportunity_status1.toLowerCase()
        : "In Progress";
      const matchesOppStatus1 =
        !filterOppStatus1 ||
        actualPrimaryStatus === filterOppStatus1.toLowerCase();
      const matchesOppStatus2 =
        !filterOppStatus2 ||
        (item.opportunity_status2 &&
          item.opportunity_status2.toLowerCase() ==
          filterOppStatus2.toLowerCase());
      const matchesManager = !filterManager
        ? true
        : filterManager.endsWith('+Self')
          ? (item.managerAssign && managers.some(
            m => m.id == item.managerAssign &&
              m.name === filterManager.replace('+Self', '')
          ))
          : (item.assign_to_manager && item.assign_to_manager.toLowerCase() == filterManager.toLowerCase());
      const matchesAssignee =
        !filterAssignee ||
        (item.assignedSalesName &&
          item.assignedSalesName.toLowerCase() == filterAssignee.toLowerCase());
           const matchesPrimarySource =
  !filterPrimarySource ||
  (item.primarySource &&
    item.primarySource.toLowerCase() === filterPrimarySource.toLowerCase());

const matchesSecondarySource =
  !filterSecondarySource ||
  (item.secondarysource &&
    item.secondarysource.toLowerCase() === filterSecondarySource.toLowerCase());
      const matchesDateRange = (() => {
        if (appliedFilterStartDate && appliedFilterEndDate) {
          const start = new Date(appliedFilterStartDate);
          const end = new Date(appliedFilterEndDate);
          const createdAt = new Date(item.created_at);
          return createdAt >= start && createdAt <= end;
        }
        return true;
      })();

      return (
        matchesFreeText &&
        matchesStatus &&
        matchesDestination &&
        matchesOppStatus1 &&
        matchesOppStatus2 &&
        matchesManager &&
        matchesAssignee &&
        matchesDateRange &&
        matchesPrimarySource &&
        matchesSecondarySource
      );
    });
  }, [
    searchTerm,
    filterStatus,
    filterDestination,
    filterOppStatus1,
    filterOppStatus2,
    filterManager,
    filterPrimarySource,
    filterSecondarySource,
    filterAssignee,
    appliedFilterStartDate,
    appliedFilterEndDate,
    data,
  ]);

 const handleAssignLead = async (leadid, associateObj, status) => {
  if (!associateObj?.id || !associateObj?.name) {
    setMessage('Please select a valid associate.');
    setTimeout(() => setMessage(''), 1000);
    return;
  }
 
  // ✅ Optimistic — instant UI update
  queryClient.setQueryData(['not-admin-leads'], (old = []) =>
    old.map((lead) =>
      lead.leadid == leadid
        ? {
            ...lead,
            assignedSalesId: associateObj.id,
            assignedSalesName: associateObj.name,
          }
        : lead
    )
  );
 
  try {
    const response = await axios.post(`${baseURL}/api/admin-assign-lead`, {
      leadid,
      employeeId: associateObj.id,
      employeeName: associateObj.name,
      status,
    });
    setMessage(response.data.message);
    setTimeout(() => setMessage(''), 1000);
  } catch {
    queryClient.invalidateQueries(['not-admin-leads']); // ✅ rollback
    setMessage('Assign failed, reverting...');
    setTimeout(() => setMessage(''), 1000);
  }
};
  const columns = useMemo(
    () => [
      { Header: "OppId", accessor: "leadid" },
      {
        Header: "Name",
        accessor: "name",
                Cell: ({ row }) => {
          const currentPage = pageIndex; 
              const params = new URLSearchParams(location.search);
    const pageSize = params.get('pageSize') || '20';
          return ( 
          <div
            style={{
              cursor: "pointer",
              color: "blue",
              textDecoration: "underline",
            }}
            onClick={() => navigate(`/a-details/${row.original.leadid}?page=${currentPage + 1}&pageSize=${pageSize}`)}
          >
            {row.original.name}
          </div>
       )
       }
      },
      {
        Header: "Mobile",
        accessor: "phone_number",
        Cell: ({ row }) => (
          <div style={{ display: "flex", alignItems: "center" }}>
            <a
              href={`https://wa.me/${row.original.phone_number}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                textDecoration: "none",
                color: "blue",
                cursor: "pointer",
              }}
              title="Chat on WhatsApp"
            >
              {row.original.phone_number}
            </a>
            <FaCopy
              style={{ marginLeft: "8px", cursor: "pointer", color: "#ff9966" }}
              onClick={() => copyToClipboard(row.original.phone_number)}
              title="Copy Phone Number"
            />
          </div>
        ),
      },
      {
        Header: "Email",
        accessor: "email",
        Cell: ({ row }) => (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between", // Push copy button to the right
              width: "100%",
              maxWidth: "200px", // Adjust width as needed
            }}
          >
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "100px",
              }}
              title={row.original.email} // Show full email on hover
            >
              {row.original.email}
            </div>
            <FaCopy
              style={{ cursor: "pointer", color: "#ff9966" }}
              onClick={() => copyToClipboard(row.original.email)}
              title="Copy Email"
            />
          </div>
        ),
      },
      {
        Header: "Destination",
        accessor: "travel_destination",
        Cell: ({ row }) => (
          <div
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100px",
            }}
            title={row.original.travel_destination}
          >
            {row.original.travel_destination}
          </div>
        ),
      },






      {
        Header: "Opportunity Status",
        accessor: "opportunityStatus",
        Cell: ({ row }) => {
          const { fontSize } = useContext(FontSizeContext);
          const { opportunity_status1, opportunity_status2, leadid } = row.original;

          // Local state for unsaved changes
          const [localPrimary, setLocalPrimary] = useState(opportunity_status1);
          const [localSecondary, setLocalSecondary] = useState(opportunity_status2);
          const [isDirty, setIsDirty] = useState(false);

          // Reset local state when original props change
          useEffect(() => {
            setLocalPrimary(opportunity_status1);
            setLocalSecondary(opportunity_status2);
            setIsDirty(false);
          }, [opportunity_status1, opportunity_status2]);

          // Get secondary options for current primary selection
          const secondaryOptions = localPrimary ? (dropdownOptions.secondary[localPrimary] || []) : [];
          const isSecondaryDisabled = !localPrimary || secondaryOptions.length === 0;

          const handlePrimaryChange = (e) => {
            const newPrimary = e.target.value;
            setLocalPrimary(newPrimary);
            setLocalSecondary(""); // Reset secondary when primary changes
            setIsDirty(true);
          };

          const handleSecondaryChange = (e) => {
            setLocalSecondary(e.target.value);
            setIsDirty(true);
          };

          const canSave =
            localPrimary &&
            (secondaryOptions.length === 0 || (secondaryOptions.length > 0 && localSecondary));

          const handleSave = async () => {
            try {
              // Update both statuses in one API call
              await updateOpportunityStatus(leadid, localPrimary, localSecondary);

              // Update local data state only after successful API call
                  queryClient.setQueryData(
  ['not-admin-leads'],
  (oldData = []) =>
    oldData.map(row =>
                  row.leadid === leadid
                    ? {
                      ...row,
                      opportunity_status1: localPrimary,
                      opportunity_status2: localSecondary
                    }
                    : row
                )
              );

              setIsDirty(false);
            } catch (error) {
              console.error('Error saving status:', error);
            }
          };

          return (
            <div className="d-flex align-items-center gap-2" style={{ fontSize: fontSize }}>
              {/* Primary Status Dropdown */}
              <select
                value={localPrimary || ""}
                onChange={handlePrimaryChange}
                className="form-select"
                style={{ fontSize: fontSize }}
              >
                <option value="">Select Primary Status</option>
                {dropdownOptions.primary.map(option => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </select>

              {/* Secondary Status Dropdown */}
              <select
                value={localSecondary || ""}
                onChange={handleSecondaryChange}
                className="form-select"
                style={{ fontSize: fontSize }}
                disabled={isSecondaryDisabled}
              >
                <option value="">Select Secondary Status</option>
                {secondaryOptions.map(option => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </select>

              {/* Save Button (only shown when there are unsaved changes) */}
              {isDirty && (
                <FaSave
                  onClick={canSave ? handleSave : undefined}
                  title={canSave ? "Save changes" : "Select secondary status to enable"}
                  style={{
                    color: canSave ? "#ff9966" : "#ccc",
                    cursor: canSave ? "pointer" : "not-allowed",
                    fontSize: "32px",
                  }}
                />
              )}
            </div>
          );
        },
      },


      {
        Header: "Manager ",
        Cell: ({ row }) => {
          const assignedManagerId = row.original.managerid || "";
          const assignedManagerName = row.original.assign_to_manager || "";

          const [selectedManager, setSelectedManager] = useState(
            assignedManagerId
              ? `${assignedManagerId}|${assignedManagerName}`
              : ""
          );
          const [showIcon, setShowIcon] = useState(false);

          useEffect(() => {
            setSelectedManager(
              assignedManagerId
                ? `${assignedManagerId}|${assignedManagerName}`
                : ""
            );
            setShowIcon(false);
          }, [assignedManagerId, assignedManagerName]);

          const handleChange = (e) => {
            const newValue = e.target.value;
            setSelectedManager(newValue);
            setShowIcon(
              newValue !== `${assignedManagerId}|${assignedManagerName}`
            );
          };

          const handleAssignClick = async () => {
            if (selectedManager) {
              const [managerid, assignee] = selectedManager.split("|");

              if (selectedManager == "self") {
                // Call the new API for self assignment
                await handleSelfAssign(row.original.leadid);
              } else {
                handleAssignToChange(
                  assignee,
                  row.original.leadid,
                  managerid,
                  row.original.status
                );
              }

              // await handleAssignToChange(assignee, row.original.leadid, managerid);

              // ✅ Update row data manually to trigger re-render
              row.original.managerid = managerid;
              row.original.assign_to_manager = assignee;

              // ✅ Update state to reflect change instantly
              setSelectedManager(`${managerid}|${assignee}`);
              setShowIcon(false);
            }
          };

          return (
            <div className="d-flex align-items-center" style={{ fontSize: fontSize }}>
              <select
                value={selectedManager}
                onChange={handleChange}
                className="form-select me-2"
                style={{ maxWidth: "150px", fontSize: fontSize }}
              >
                <option value="">Select Assignee</option>
                <option value="self">Self</option>
                {managers.map((manager, index) => (
                  <option key={index} value={`${manager.id}|${manager.name}`}>
                    {manager.name}
                  </option>
                ))}
              </select>
              {showIcon && (
                <HiUserGroup
                  style={{
                    color: "#ff9966",
                    cursor: "pointer",
                    fontSize: "18px",
                  }}
                  onClick={handleAssignClick}
                />
              )}
            </div>
          );
        },
      },

      {
        Header: "Associate",
        Cell: ({ row }) => {
          const initialAssociateValue = row.original.assignedSalesId
            ? `${row.original.assignedSalesId}|${row.original.assignedSalesName}`
            : "";

          const [selectedAssociate, setSelectedAssociate] = useState(
            initialAssociateValue
          );
          const [showIcon, setShowIcon] = useState(false);

          const managerId = row.original.managerid;
          const associates = managerId
            ? associatesByManager[managerId] || []
            : [];

          useEffect(() => {
            setSelectedAssociate(initialAssociateValue);
            setShowIcon(false);
          }, [row.original.assignedSalesId, row.original.assignedSalesName]);

          const handleChange = (e) => {
            const newValue = e.target.value;
            setSelectedAssociate(newValue);
            setShowIcon(newValue !== initialAssociateValue);
          };

          const handleAssignClick = async () => {
            if (selectedAssociate) {
              const [associateId, associateName] = selectedAssociate.split("|");
              await handleAssignLead(
                row.original.leadid,
                { id: associateId, name: associateName },
                row.original.status
              );
              // No need to update row.original directly; state is already updated in handleAssignLead
              setShowIcon(false);
            }
          };

          return (
            <div className="d-flex align-items-center" style={{ fontSize: fontSize }}>
              <select
                value={selectedAssociate}
                onChange={handleChange}
                className="form-select me-2"
                style={{ maxWidth: "150px", fontSize: fontSize }}
              >
                <option value="">Select Associate</option>
                {associates.map((associate, index) => (
                  <option
                    key={index}
                    value={`${associate.id}|${associate.name}`}
                  >
                    {associate.name}
                  </option>
                ))}
              </select>
              {showIcon && (
                <HiUserGroup
                  style={{
                    color: "#ff9966",
                    cursor: "pointer",
                    fontSize: "18px",
                  }}
                  onClick={handleAssignClick}
                />
              )}
            </div>
          );
        },
      },
      {
        Header: "Action",
        Cell: ({ row }) => {
          const currentPage = pageIndex; // Capture current page index
                  const params = new URLSearchParams(location.search);
    const pageSize = params.get('pageSize') || '20';

          return (

            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <FaEdit
                style={{ color: "#ff9966", cursor: "pointer" }}
                onClick={() => handleEdit(row.original.leadid, currentPage,pageSize)}
              />
              <FaEye
                style={{ color: "#ff9966", cursor: "pointer" }}
                onClick={() => navigate(`/a-details/${row.original.leadid}?page=${currentPage + 1}&pageSize=${pageSize}`)}
              />
              <FaTrash
                style={{ color: "#ff9966", cursor: "pointer" }}
                onClick={() => handleArchive(row.original.leadid, currentPage  ,pageSize)}
              />
                          <FaComment
                style={{ color: "#ff9966", cursor: "pointer" }}
                onClick={() => handleCommentClick(row.original,)}
              />
               {/* <FaComment
                              style={{ color: "#ff9966", cursor: "pointer" }}
                              onClick={() => navigate(`/a-opportunity-comments/${row.original.leadid}?page=${currentPage + 1}&pageSize=${pageSize}`)}
                            /> */}
              <FaRupeeSign
                style={{ color: "#ff9966", cursor: "pointer" }}
                onClick={() =>
                  navigate(`/a-payments/${row.original.leadid}?page=${currentPage + 1}&pageSize=${pageSize}`, {
                    state: { leadid: row.original.leadid },
                  })
                }
              />
            </div>
          )
        },
      },
    ],
    [dropdownOptions, pageIndex, location,managers, associatesByManager]
  );



  const uniqueDestinations = useMemo(() => {
    // Filter out empty destinations and normalize valid ones
    const normalizedDestinations = data
      .map((item) => item.travel_destination?.trim()) // Trim spaces and handle potential undefined/null values
      .filter((dest) => dest) // Remove empty values
      .map((dest) => dest.toLowerCase()); // Convert to lowercase for uniqueness

    // Get unique values and format them
    return [...new Set(normalizedDestinations)].map(
      (dest) => dest.charAt(0).toUpperCase() + dest.slice(1)
    ); // Capitalize first letter
  }, [data]);

  // Extract team members for the selected manager
  const teamMembers = useMemo(() => {
    if (!filterManager) return [];
    const selectedManager = managers.find(
      (manager) => manager.name.toLowerCase() == filterManager.toLowerCase()
    );
    return selectedManager ? selectedManager.teamMembers : [];
  }, [filterManager, managers]);

  return (
    <div className="salesOpportunitycontainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`salesOpportunity ${collapsed ? "collapsed" : ""}`}>
        <div className="potentialleads-table-container">
          <Row className="mb-3">
            <Col className="d-flex justify-content-between align-items-center fixed">
              <h3>Opportunity Details</h3>
              {message && <div className="alert alert-info">{message}</div>}
            </Col>
          </Row>
          <Row className="mb-3 align-items-center">
            <Col md={6} className="d-flex align-items-center gap-2">
              <input
                type="text"
                className="form-control"
                placeholder="Free Text Search..."
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  localStorage.setItem("searchTerm", e.target.value);
                      setPageIndex(0);
    const url = new URL(window.location);
    url.searchParams.delete('page');
    window.history.pushState({}, '', url);

                }} />
              {showDateRange ? (
                <FaTimes
                  onClick={() => {
                    setShowDateRange(false);
                    localStorage.setItem("showDateRange", "false");
                    setFilterStartDate("");
                    setFilterEndDate("");
                    setAppliedFilterStartDate("");
                    setAppliedFilterEndDate("");
                    localStorage.removeItem("filterStartDate");
                    localStorage.removeItem("filterEndDate");
                    localStorage.removeItem("appliedFilterStartDate");
                    localStorage.removeItem("appliedFilterEndDate");
                  }}
                  style={{ cursor: "pointer", fontSize: "1.5rem" }}
                  title="Hide Date Range"
                />
              ) : (
                <FaCalendarAlt
                  onClick={() => {
                    setShowDateRange(true);
                    localStorage.setItem("showDateRange", "true");
                  }} style={{ cursor: "pointer", fontSize: "1.5rem" }} title="Show Date Range" />
              )}
              {showDateRange && (
                <div className="d-flex align-items-center gap-2">
                  <input
                    type="date"
                    className="form-control"
                    value={filterStartDate}
                    onChange={(e) => setFilterStartDate(e.target.value)}
                  />
                  <span>to</span>
                  <input
                    type="date"
                    className="form-control"
                    value={filterEndDate}
                    onChange={(e) => setFilterEndDate(e.target.value)}
                  />
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      setAppliedFilterStartDate(filterStartDate);
                      setAppliedFilterEndDate(filterEndDate);
                          setPageIndex(0);
    const url = new URL(window.location);
    url.searchParams.delete('page');
    window.history.pushState({}, '', url);

                    }}
                  >
                    OK
                  </button>
                </div>
              )}
            </Col>
            <Col md={6} className="d-flex justify-content-end">
              <button className="btn btn-secondary" onClick={clearFilters}>
                Clear Filters
              </button>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={3}>
              <select
                className="form-select"
                value={filterDestination}
 onChange={(e) => { 
    setFilterDestination(e.target.value);
    // ADD THESE 3 LINES:
    setPageIndex(0);
    const url = new URL(window.location);
    url.searchParams.delete('page');
    window.history.pushState({}, '', url);
  }}
                
              >
                <option value=""> Destinations</option>
                {uniqueDestinations.map((dest) => (
                  <option key={dest} value={dest}>
                    {dest}
                  </option>
                ))}
              </select>
            </Col>
            <Col md={2}>
              <select
                className="form-select"
                value={filterOppStatus1}
                onChange={(e) => {
                  setFilterOppStatus1(e.target.value);
                  setFilterOppStatus2("");
                      setPageIndex(0);
    const url = new URL(window.location);
    url.searchParams.delete('page');
    window.history.pushState({}, '', url);

                }}
              >
                <option value="">Primary Status</option>
                {dropdownOptions.primary.map((status) => (
                  <option key={status} value={status}>
                    {status}
                  </option>
                ))}
              </select>
            </Col>
            <Col md={2}>
              <select
                className="form-select"
                value={filterOppStatus2}
                onChange={(e) => { setFilterOppStatus2(e.target.value)
                      setPageIndex(0);
    const url = new URL(window.location);
    url.searchParams.delete('page');
    window.history.pushState({}, '', url);

                }}
              >
                <option value="">Secondary Status</option>
                {dropdownOptions.secondary[filterOppStatus1]?.map((status) => (
                  <option key={status} value={status}>
                    {status}
                  </option>
                ))}
              </select>
            </Col>
            <Col md={2}>
              <select
                className="form-select"
                value={filterManager}
                onChange={(e) => {
                  setFilterManager(e.target.value);
                  setFilterAssignee("");
                }}
              >
                <option value=""> Managers</option>
                {Array.isArray(managers) &&
                  managers.flatMap((manager) => [
                    <option key={`${manager.id}-regular`} value={manager.name}>
                      {manager.name}
                    </option>,
                    <option key={`${manager.id}-self`} value={`${manager.name}+Self`}>
                      {manager.name} + Self
                    </option>
                  ])
                }
              </select>
            </Col>
            <Col md={3}>
              <select
                className="form-select"
                value={filterAssignee}
                onChange={(e) => { setFilterAssignee(e.target.value)
                      setPageIndex(0);
    const url = new URL(window.location);
    url.searchParams.delete('page');
    window.history.pushState({}, '', url);

                }}
              >
                <option value="">Associates</option>
                {teamMembers.map((member) => (
                  <option key={member.id} value={member.name}>
                    {member.name}
                  </option>
                ))}
              </select>
            </Col>
          </Row>
           <Row className="mb-3">
                      <Col md={3}>
                        <select
                          className="form-select"
                          value={filterPrimarySource}
                          onChange={(e) => {
                            setFilterPrimarySource(e.target.value);
                            setFilterSecondarySource(""); // reset secondary
                            setPageIndex(0);
                      
                            const url = new URL(window.location);
                            url.searchParams.delete("page");
                            window.history.pushState({}, "", url);
                          }}
                        >
                          <option value="">Primary Source</option>
                         {primarySourceOptions.map((source) => (
                            <option key={source} value={source}>
                              {source}
                            </option>
                          ))}
                        </select>
                      </Col>
                      <Col md={3}>
                        <select
                          className="form-select"
                          value={filterSecondarySource}
                          onChange={(e) => {
                            setFilterSecondarySource(e.target.value);
                            setPageIndex(0);
                      
                            const url = new URL(window.location);
                            url.searchParams.delete("page");
                            window.history.pushState({}, "", url);
                          }}
                          disabled={!filterPrimarySource}
                        >
                          <option value="">Secondary Source</option>
                          {sourceDropdownOptions[filterPrimarySource]?.map((source) => (
                            <option key={source} value={source}>
                              {source}
                            </option>
                          ))}
                        </select>
                      </Col>
                      </Row>
          {/* Add loader - replace the existing conditional rendering */}
          {isLoading ? (
  <Loader />
) : data.length === 0 ? (
            <div className="text-center p-5">
              <p>No data available</p>
            </div>
          ) : (
            <DataTable
              columns={columns}
              data={filteredData}
              pageIndex={pageIndex}
              setPageIndex={setPageIndex}
            />
          )}
        </div>
      </div>
{/* Comment Modal Component */}
<My_EmailHistory
  show={showCommentModal}
  onHide={() => {
    setShowCommentModal(false);
    setSelectedLeadForComment(null);
  }}
  selectedLead={selectedLeadForComment}
  baseURL={baseURL} // Pass the baseURL
/>
    </div>
  );
};

export default Potentialleads;
